import { useEffect } from 'react'

import { type HeaderState, useHeaderContext } from '@/lib/provider/HeaderContext'

export const usePageHeader = ({ title, showQuickSelection, isFullPage }: Partial<Pick<HeaderState, 'title' | 'showQuickSelection' | 'isFullPage'>>) => {
  const { setTitle, setIsFullPage, setShowQuickSelection } = useHeaderContext()

  useEffect(() => {
    setTitle(title ?? '')
    return () => setTitle('')
  }, [title, setTitle])

  useEffect(() => {
    setShowQuickSelection(showQuickSelection ?? true)
    return () => setShowQuickSelection(true)
  }, [showQuickSelection, setShowQuickSelection])

  useEffect(() => {
    setIsFullPage(isFullPage ?? false)
    return () => setIsFullPage(false)
  }, [isFullPage, setIsFullPage])
}